// extracted by mini-css-extract-plugin
module.exports = {"header":"bwh5H","title":"GZHda"};